import { render, staticRenderFns } from "./GrupoProdutoList.vue?vue&type=template&id=13ab5404&scoped=true"
import script from "./GrupoProdutoList.vue?vue&type=script&lang=js"
export * from "./GrupoProdutoList.vue?vue&type=script&lang=js"
import style0 from "./GrupoProdutoList.vue?vue&type=style&index=0&id=13ab5404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ab5404",
  null
  
)

export default component.exports